var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHashtag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.8,15H70.4l4.3-11.3c0.4-1.1-0.2-2.4-1.3-2.8c-1.1-0.4-2.4,0.2-2.8,1.3L65.7,15H45l4.3-11.3 c0.4-1.1-0.1-2.4-1.3-2.8c-1.1-0.4-2.4,0.2-2.8,1.3L40.3,15H27.6c-1.2,0-2.2,1-2.2,2.2c0,1.2,1,2.2,2.2,2.2h11l-7.1,18.7H19.2 c-1.2,0-2.2,1-2.2,2.2c0,1.2,1,2.2,2.2,2.2h10.7l-4.5,12c-0.4,1.1,0.1,2.4,1.3,2.8c0.3,0.1,0.5,0.1,0.8,0.1c0.9,0,1.7-0.5,2-1.4 l5.1-13.6h20.7l-4.5,12c-0.4,1.1,0.1,2.4,1.3,2.8c0.3,0.1,0.5,0.1,0.8,0.1c0.9,0,1.7-0.5,2.1-1.4L60,42.5h12.3c1.2,0,2.2-1,2.2-2.2 c0-1.2-1-2.2-2.2-2.2H61.7l7.1-18.7h12.1c1.2,0,2.2-1,2.2-2.2C83,16,82,15,80.8,15z M36.3,38.1L36.3,38.1L36.3,38.1L36.3,38.1z  M57,38.1H39.5l10.9-7.5c0.8-0.6,1-1.7,0.5-2.5c-0.6-0.8-1.7-1-2.5-0.5l-10.9,7.5l5.9-15.8h20.7L57,38.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.5,87.1v6.5h-1.5v-6.4c0-2.4-1.2-3.6-3.4-3.6c-2.4,0-3.9,1.5-3.9,4.1v5.9H8.1V77.8h1.5v6.6 c0.8-1.3,2.3-2.1,4.2-2.1C16.6,82.3,18.5,83.9,18.5,87.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.1,86.7v7h-1.5v-1.8c-0.7,1.2-2,1.9-3.9,1.9c-2.5,0-4.1-1.3-4.1-3.3c0-1.7,1.1-3.2,4.3-3.2h3.6v-0.7 c0-1.9-1.1-3-3.2-3c-1.5,0-2.8,0.5-3.7,1.3l-0.7-1.1c1.1-1,2.8-1.5,4.6-1.5C29.4,82.3,31.1,83.8,31.1,86.7z M29.5,90.3v-1.8H26 c-2.2,0-2.9,0.9-2.9,2c0,1.3,1,2.1,2.8,2.1C27.7,92.5,28.9,91.7,29.5,90.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.6,92.3l0.7-1.2c0.9,0.7,2.4,1.3,4,1.3c2.1,0,3-0.7,3-1.8c0-2.9-7.3-0.6-7.3-5.1c0-1.8,1.6-3.2,4.4-3.2 c1.5,0,3,0.4,4,1l-0.7,1.2c-1-0.7-2.2-1-3.3-1c-2,0-2.9,0.8-2.9,1.9c0,3,7.3,0.7,7.3,5.1c0,1.9-1.7,3.2-4.6,3.2 C36.3,93.7,34.6,93.1,33.6,92.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56,87.1v6.5h-1.5v-6.4c0-2.4-1.2-3.6-3.4-3.6c-2.4,0-3.9,1.5-3.9,4.1v5.9h-1.5V77.8h1.5v6.6 c0.8-1.3,2.3-2.1,4.2-2.1C54.1,82.3,56,83.9,56,87.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66,92.9c-0.6,0.5-1.5,0.8-2.4,0.8c-2.1,0-3.3-1.2-3.3-3.3v-6.8h-2v-1.3h2v-2.5h1.5v2.5h3.4v1.3h-3.4v6.7 c0,1.3,0.7,2.1,1.9,2.1c0.6,0,1.2-0.2,1.7-0.6L66,92.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.3,86.7v7h-1.5v-1.8c-0.7,1.2-2,1.9-3.9,1.9c-2.5,0-4.1-1.3-4.1-3.3c0-1.7,1.1-3.2,4.3-3.2h3.6v-0.7 c0-1.9-1.1-3-3.2-3c-1.5,0-2.8,0.5-3.7,1.3l-0.7-1.1c1.1-1,2.8-1.5,4.6-1.5C75.6,82.3,77.3,83.8,77.3,86.7z M75.8,90.3v-1.8h-3.5 c-2.2,0-2.9,0.9-2.9,2c0,1.3,1,2.1,2.8,2.1C73.9,92.5,75.2,91.7,75.8,90.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.9,82.4v9.9c0,3.9-1.9,5.6-5.6,5.6c-2.1,0-4.1-0.6-5.2-1.7l0.8-1.2c1.1,1,2.7,1.5,4.4,1.5 c2.8,0,4.1-1.3,4.1-4.1V91c-0.9,1.4-2.5,2.2-4.4,2.2c-3.2,0-5.6-2.2-5.6-5.5c0-3.2,2.4-5.4,5.6-5.4c1.9,0,3.5,0.8,4.4,2.2v-2.2 H91.9z M90.4,87.7c0-2.4-1.8-4.1-4.3-4.1c-2.5,0-4.3,1.7-4.3,4.1c0,2.4,1.8,4.1,4.3,4.1C88.6,91.9,90.4,90.2,90.4,87.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtag);
export default __webpack_public_path__ + "static/media/hashtag.08ab739dad3b1daf4e6245a6ed46659e.svg";
export { ForwardRef as ReactComponent };